import { FC } from 'react';

import { useFormik } from 'formik';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { AdForm } from '../form';

import css from './AddAdsForm.module.css';

import { adsService } from 'v2/api/adsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { handleHttpError } from 'v2/utils';

interface AddAdsFormProps {
  onSuccess: VoidFunction;
}

export const AddAdsForm: FC<AddAdsFormProps> = ({ onSuccess }) => {
  const { trigger, isMutating } = useSWRMutation('createAd', adsService.createAd, {
    onSuccess: () => {
      onSuccess();
      toast.success('The ad has been successfully created');
      formik.resetForm();
    },
    onError: handleHttpError,
  });

  const formik = useFormik<AdForm>({
    initialValues: { key: '' },
    onSubmit: (values) => {
      trigger(values);
    },
  });

  return (
    <Card className={css.addAdFormContainer}>
      <CardHeader title="Create New Ad" icon={Plus} />

      <form className="form" onSubmit={formik.handleSubmit}>
        <TextField
          name="key"
          value={formik.values.key}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label="Key"
          required
        />

        <Button type="submit" loading={isMutating} variant="contained" size="large">
          Create
        </Button>
      </form>
    </Card>
  );
};
